// extracted by mini-css-extract-plugin
export default {"scrollLayout":"ak8vHU","scrollLayoutContent":"bk8vHU","layout":"ck8vHU","layoutContent":"dk8vHU"};